import { hotEvents } from '@/mocks/events';

export default function TopicsSection() {
  return (
    <section id="topics" className="scroll-mt-16 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-flashlight-line text-sm"></i> 热点追踪
            </span>
            <h2 className="heading-font mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">近期正在追踪的事件</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              从现场细节到舆论反转，每一起事件都标注当前核实状态，方便你快速定位重点。
            </p>
          </div>
          <a href="#facts" className="hidden items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700 sm:inline-flex">
            查看真相梳理 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {hotEvents.map((ev) => (
            <article key={ev.id} data-product-shop className="group overflow-hidden rounded-lg bg-background-50 transition-transform duration-300 hover:-translate-y-1">
              <div className="relative h-44 w-full overflow-hidden">
                <img src={ev.image} alt={`${ev.title}追踪配图`} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                <span className="absolute left-3 top-3 rounded-md bg-background-950/70 px-2.5 py-1 text-xs font-semibold text-background-50 backdrop-blur">{ev.category}</span>
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-fire-fill"></i> {ev.heat}
                </span>
              </div>
              <div className="p-5">
                <h3 className="heading-font text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">{ev.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{ev.summary}</p>
                <div className="mt-4 flex flex-wrap items-center justify-between gap-2 border-t border-background-100 pt-4">
                  <span className="text-xs text-foreground-400">{ev.time}</span>
                  <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-800">
                    <i className="ri-refresh-line"></i> {ev.status}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}